import { Goal, ID } from '@griply/types';

import { getArchivedGoalIds } from '../derived-goal-state';

export type FilterGoalsOptions = {
  hideUnplanned?: boolean;
  hideCompleted?: boolean;
  hideArchived?: boolean;
};

export const filterGoals = (
  goals: Goal[],
  { hideUnplanned, hideCompleted, hideArchived }: FilterGoalsOptions,
): Goal[] => {
  if (!hideUnplanned && !hideCompleted && !hideArchived) {
    return goals;
  }

  const archivedIds = hideArchived ? getArchivedGoalIds(goals) : new Set<ID>();

  return goals.filter((goal) => {
    if (hideUnplanned && (!goal.startDate || !goal.deadline)) {
      return false;
    }

    if (hideCompleted && !!goal.completedAt) {
      return false;
    }

    return !(hideArchived && archivedIds.has(goal.id));
  });
};
